













































import {Vue, Component, Watch} from 'vue-property-decorator'
import * as _ from 'lodash';
import dataProxy from '@/services/data-proxy.service'
import moment from "moment";

@Component({})
export default class Izvestaji extends Vue {

    data = [];
    header = [];
    godina = new Date().getFullYear();
    godine = [new Date().getFullYear(), new Date().getFullYear() - 1];
    meseci = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    mesec = moment().get('month') + 1;
    grupeVozila = [];
    grupaVozila = '';
    kategorijeVozila = [];
    kategorijaVozila = '';
    vozilo = '';
    isBusy = false;

    async created() {
        this.header = [
            '',
            this.$i18n.t('januar'),
            this.$i18n.t('februar'),
            this.$i18n.t('mart'),
            this.$i18n.t('april'),
            this.$i18n.t('maj'),
            this.$i18n.t('jun'),
            this.$i18n.t('jul'),
            this.$i18n.t('avgust'),
            this.$i18n.t('septembar'),
            this.$i18n.t('oktobar'),
            this.$i18n.t('novembar'),
            this.$i18n.t('decembar'),
            this.$i18n.t('total'),
            this.$i18n.t('prosek'),
        ];
        this.grupeVozila = await dataProxy.vratiGrupeVozila();
        this.grupeVozila.unshift({id: '', naziv: this.$i18n.t('sve grupe')});
        this.kategorijeVozila = await dataProxy.vratiKategorijeVozila();
        this.kategorijeVozila.unshift({id: '', naziv: this.$i18n.t('sve kategorije')});
        this.loadReport();
    }

    @Watch('godina')
    @Watch('grupaVozila')
    @Watch('kategorijaVozila')
    @Watch('mesec')
    async onCriteriaChanged() {
        this.loadReport();
    }

    async loadReport() {
        this.isBusy = true;
        try {
            this.data = await dataProxy.vratiTroskoveOdrzavanjaPoMesecima(this.godina, +this.grupaVozila || null, +this.kategorijaVozila || null, null, this.mesec);
        } finally {
            this.isBusy = false;
        }
    }

    isTitleCell(row) {
        const firsElement = _.head(row);
        const indexOfEmpty = row.indexOf("");
        return firsElement && indexOfEmpty != -1;
    }

    isTotalCell(row) {
        const firstElement = _.head(row);
        return !firstElement;
    }

    IsNumber(value): boolean {
        return typeof value == "number";
    }
}
